<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="carBox">
            <div class="mainBody">
                <div class="searchBox">
                    <el-button type="primary"  @click="addRole">添加</el-button>
                    <el-button type="danger"  @click="delAll">删除</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="org_name" label="项目名称" sortable="custom"></el-table-column>
                        <el-table-column prop="role_name" label="角色名称" sortable="custom"></el-table-column>
                        <el-table-column prop="role_type" label="角色类型" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.role_type, "role_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_jishu" label="技术服务人员" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.is_jishu, "yesNo") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" plain type="primary" @click="del(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <RoleList
                    width="1000px"
                    :org_id="org_id"
                    title="分配角色"
                    :isshow="selectshow"
                    @selectRole="selectRole"
                    @on-close="closeSelectDialog">
                </RoleList>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";
import RoleList from "./rolelist";
import { allocation } from "@/api/role";

export default {
    name: 'orgRole1',
    mixins: [listutil],
    components: {RoleList},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        org_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_org_id = this.org_id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '分配角色',
            menu_id: 1220,
            list_url: "/api/admin/orgrole/list",
            enu_name: ['role_type', 'yesNo'],
            search_Obj: {
                f_org_id: '',
            },
            showflag: false,
            del_Obj:{
                url:'/api/admin/orgrole/del',
                data:{
                    ids:''
                }
            },
            selectshow: false,
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        addRole(){
            this.selectshow = true
        },
        selectRole(role_ids){
            this.selectshow = false
            allocation(this.org_id, role_ids).then(res=>{
                if(res.code == 1){
                    this.$msgs("分配成功")
                    this.getListData();
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeSelectDialog(){
            this.selectshow = false
        },
    }
};
</script>